import Swiper, { Pagination } from 'swiper';

export default (sliderId) => {
	const swiperObj = new Swiper('.reference-slider-' + sliderId, {
		modules: [Pagination],
		pagination: {
			el: '.swiper-pagination',
		},
	});
	return {
		swiperObj: swiperObj,
	};
};
